import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import { t as i18nT } from "../i18n";


const AdminLayout = () => {
  const ownerLinks = [
    { name: i18nT("common.dashboard"), to: "/owner/dashboard" },
    { name: i18nT("common.myTests"), to: "/owner/my-tests" },
    { name: i18nT("common.salesAndReports"), to: "/owner/sales-reports" },
    { name: i18nT("common.profile"), to: "/owner/profile" },
  ];

  return (
    <div className="xima-mobile-scroll-page flex h-screen bg-[#050403] text-[#f8f2e6]">
      <Sidebar links={ownerLinks} />
      <div className="flex-1 flex flex-col">
        <Header />
        <main className="xima-mobile-scroll-main xima-admin-surface flex-1 overflow-y-auto bg-[#0b0805] p-6">
          <Outlet /> {/* This renders the child routes */}
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default AdminLayout;
